/* eslint-disable react/jsx-curly-newline */
/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import ExternalSelectAutocomplete from 'react-select';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// components
import { Grid, Message, Input, SelectAutocomplete, Radio } from '@design-system-coopeuch/web';
import ItemValidation from '../../molecules/ItemValidation/ItemValidation';
import SimpleCard from '../../molecules/SimpleCard/SimpleCard';

import Skeleton from '../../atoms/Skeleton/Skeleton';
// constants
import { MAX_EXECUTIVE_CODE } from '../../../../domain/constants';

// styles
import { StyledWrapperInput, WrapperRadio } from '../../../assets/styles/styles';

// assets
import iconExecutive from '../../../assets/img/icon-executive.svg';

const CardPreferredOffice = (props) => {
  const {
    regionsWithOfficesItems,
    officesItems,
    preferredOffice,
    executiveCode,
    executive,
    executiveAttending,
    isVisiblePreferredOffice,
    isLoadingFetchExecutive,
    isValidExecutiveCode,
    isMobileDevice,
    disabled,
    onChange,
    onChangeRegion,
    onChangeOffice,
    onChangeExecutiveCode,
  } = props;

  // TODO: resolver position absolute de inputsSelects, por ahora se puso <br />
  return (
    <SimpleCard
      contentHeader={
        <article className="d-flex flex-column">
          <p className="simplecard__title">Sucursal de preferencia para ser atendido</p>
          <p className="simplecard_subtitle">
            A través de esta sucursal atenderemos tus necesidades y gestionaremos tus ofertas
            comerciales
          </p>
        </article>
      }
      disabled={disabled}
    >
      <Grid className="m-0 padding-16 p-md-6">
        <Grid className="p-0 mb-2">
          <p className="font-size-16 line-height-24 font-weight-bold">¿Cuál quieres que sea tu sucursal?</p>
        </Grid>
        <Grid className="p-0 m-0" row>
          <Grid className="p-0 m-0 mb-4 mb-md-0" col={12} md={4}>
            <SelectAutocomplete
              label="Región"
              className="select-autocomplete-coopeuch"
              defaultInputValue=""
              keyPar={['id', 'region']}
              noOptionsMessage={() => 'Sin opciones'}
              placeholder=""
              onChange={(item) => onChangeRegion(item)}
              options={regionsWithOfficesItems}
            />
          </Grid>
          <Grid className="p-0 m-0 pl-md-4" col={12} md={8}>
            <label className="label-select-autocomplete">Sucursal</label>
            <ExternalSelectAutocomplete
              className="select-autocomplete-coopeuch external-select-autocomplete"
              classNamePrefix="select-autocomplete-coopeuch"
              value={{
                value: preferredOffice.value.id,
                label: preferredOffice.value.name,
              }}
              noOptionsMessage={() => 'Sin opciones'}
              onChange={(item) => onChangeOffice(item)}
              options={officesItems}
            />
          </Grid>
        </Grid>
        {isVisiblePreferredOffice && (
          <Message
            className="mt-3"
            type="info"
            title={`La sucursal ingresada se encuentra ubicada en ${preferredOffice.value.address}, ${preferredOffice.value.commune}.`}
            closer={null}
          />
        )}
      </Grid>
      <Grid className="m-0 padding-16 p-md-6 border-top border-neutral-alfa-15">
        <Grid className="m-0 p-0">
          <p className="mb-2 font-size-16 font-weight-bold line-height-24">
            ¿Te está atendiendo un ejecutivo?
          </p>
          <WrapperRadio>
            <Radio
              name="accepted"
              label="Sí"
              checked={executiveAttending.value === 'SI'}
              onChange={() =>
                onChange({
                  field: 'executiveAttending',
                  property: 'value',
                  value: 'SI',
                })
              }
            />
          </WrapperRadio>
          <WrapperRadio>
            <Radio
              name="notAccepted"
              label="No"
              checked={executiveAttending.value === 'NO'}
              onChange={() =>
                onChange({
                  field: 'executiveAttending',
                  property: 'value',
                  value: 'NO',
                })
              }
            />
          </WrapperRadio>
        </Grid>
        {executiveAttending.value === 'SI' && (
          <Grid className="p-0 m-0 mt-2 d-flex flex-column" row>
            {isLoadingFetchExecutive ? (
              <>
                <Skeleton height="18px" width="180px" mb={4} />
                <Skeleton height="50px" width={isMobileDevice ? '100%' : '270px'} mb={4} />
                <Skeleton height="18px" width="50px" mb={0} />
              </>
            ) : (
              <Grid row className="p-0 m-0">
                <Grid className="p-0 m-0" col={12} md={4}>
                  <StyledWrapperInput withoutmaxlength>
                    <Input
                      value={executiveCode.value}
                      label="Ingresa el código (opcional)"
                      placeholder="Ejemplo: PHLM"
                      maxLength={MAX_EXECUTIVE_CODE}
                      onChange={(value) => onChangeExecutiveCode(value)}
                      allowSpaces
                      autoComplete="new-password"
                    />
                  </StyledWrapperInput>
                  <article className="p-0 pt-1">
                    {/* isValidExecutiveCode === 'optional' && (
                      <p className="text-color-64 font-size-12">Opcional</p>
                    ) */}
                    {isValidExecutiveCode === 'valid' && executiveCode.value.length === 4 && (
                      <ItemValidation type="success" fontSize="12" className={classNames('mt-0')}>
                        <p className="text-color-success line-height-20">
                          Código correcto
                        </p>
                      </ItemValidation>
                    )}
                    {isValidExecutiveCode === 'invalid' && (
                      <p className="text-color-64 font-size-12 line-height-18">
                        No tenemos registro de este código. Vuelve a intentarlo o continúa
                      </p>
                    )}
                  </article>
                </Grid>
                {executive.nombre && executiveCode.value.length === 4 && (
                  <Grid
                    className="p-0 mb d-flex align-items-start pt-3 pt-md-7 pl-md-5"
                    col={12}
                    md={8}
                  >
                    <img src={iconExecutive} width="24" alt="ejecut" />
                    <p className="ml-1 font-size-16 line-height-20 font-weight-bold text-color-38">
                      {executive.nombre || 'XXXX'}
                    </p>
                  </Grid>
                )}
              </Grid>
            )}
          </Grid>
        )}
      </Grid>
    </SimpleCard>
  );
};

CardPreferredOffice.defaultProps = {
  preferredOffice: {
    value: {
      name: '',
      region: '',
      commune: '',
    },
  },
  officesItems: [],
  disabled: false,
  isVisiblePreferredOffice: false,
};

CardPreferredOffice.propTypes = {
  preferredOffice: PropTypes.shape({
    value: PropTypes.shape({
      name: PropTypes.string,
      region: PropTypes.string,
      commune: PropTypes.string,
    }),
  }),
  officesItems: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  isVisiblePreferredOffice: PropTypes.bool,
};

export default CardPreferredOffice;
